<template>
    <option value="imperial">Imperial (miles, farenheit)</option>
    <option value="metric">Metric (kilometers, celcius)</option>
</template>
